'use client';

import {twMerge} from 'tailwind-merge';
import recordEvent from 'src/utils/recordEvent';

type Props = {
  className?: string;
  visualComponent?: React.ReactNode;
  longText: string;
  shortText: string;
  buttonCopy: string;
  href: string;
  plausibleEventName: string;
  plausibleEventProps?: Record<string, string>;
};

const AdBanner = ({
  visualComponent,
  longText,
  shortText,
  buttonCopy,
  href,
  className,
  plausibleEventName,
  plausibleEventProps
}: Props) => {
  return (
    <div className={twMerge('flex justify-center grow w-full pt-2 px-(--page-padding) max-[600px]:mb-4', className)}>
      <a
        href={href}
        onClick={() => recordEvent(plausibleEventName, {props: plausibleEventProps})}
        target="_blank"
        className="group rounded-full grow max-w-[700px] p-1 pl-4 text-sm text-black/70 dark:text-white/70 bg-[rgba(0,0,0,0.03)] dark:bg-[rgba(255,255,255,0.04)] hover:bg-[rgba(0,0,0,0.06)] dark:hover:bg-[rgba(255,255,255,0.05)] transition-colors flex justify-between items-center gap-2 h-9"
        rel="noreferrer"
      >
        <div className="flex items-center gap-2 grow shrink min-w-0">
          {visualComponent}
          <span className="grow truncate shrink min-w-0 max-[600px]:hidden">{longText}</span>
          <span className="grow truncate shrink min-w-0 max-[600px]:block hidden">{shortText}</span>
        </div>

        <span className="bg-(--page-background) group-hover:bg-(--purple) rounded-full px-3 py-1 font-semibold text-black/70 dark:text-white/70 group-hover:text-white dark:group-hover:text-white transition group-hover:primary-button-shadow shrink-0 max-[600px]:hidden">
          {buttonCopy}
        </span>
      </a>
    </div>
  );
};

export default AdBanner;
